<template>
  <v-card outlined class="pa-4 mb-4" min-width="318">
    <div class="d-flex ">
      <div
        class="d-flex flex-column justify-space-between"
        style="min-width: 50%; min-height: 115px;"
      >
        <div>
          <div class="d-flex ">
            <div
              class="entity-type-icon mr-2 d-flex justify-center rounded-circle flex-shrink-0"
            >
              <v-skeleton-loader
                class="avatar-container"
                type="image"
                :width="'40px'"
                :height="'40px'"
                :min-width="'40px'"
                :min-height="'40px'"
              />
            </div>

            <div class="d-flex flex-column" style="width: 50%">
              <v-skeleton-loader type="sentences"></v-skeleton-loader>
            </div>
          </div>
        </div>

        <v-skeleton-loader
          type="sentences"
          :width="'100px'"
          class="mt-2"
        ></v-skeleton-loader>

        <div class="d-flex align-center">
          <v-skeleton-loader
            class="avatar-container"
            type="image"
            :width="'38px'"
            :height="'38px'"
            :min-width="'38x'"
            :min-height="'38px'"
          />
          <v-skeleton-loader
            type="text"
            :width="'60px'"
            class="pl-2"
          ></v-skeleton-loader>
        </div>
      </div>
      <div class="d-flex justify-end" style="width: 100%">
        <v-skeleton-loader
          type="image"
          :width="'112px'"
          :height="'112px'"
          :min-width="'112px'"
          :min-height="'112px'"
        ></v-skeleton-loader>
      </div>
    </div>
    <v-card-actions class="pa-0 mt-4 mb-0 d-flex justify-center">
      <v-skeleton-loader
        class="chip"
        type="image"
        :width="'318px'"
        :height="'25px'"
        :min-width="'318x'"
        :min-height="'25px'"
      ></v-skeleton-loader>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'RevCardSkeleton',

  props: {
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar-container {
  border-radius: 50%;
}
.chip {
  border-radius: 30px;
  border: none;
}
</style>
